// Infinite horizontal running text ribbon — sits below the navbar for animated brand polish.
import { Sparkles } from "lucide-react";

const ITEMS = [
    "Vedic Astrology",
    "Karma Guide",
    "Bhrigu Nandi Nadi (BNN) Expert",
    "Financial Astrology",
    "Marriage Matching",
    "Numerology — Chaldean",
    "Business & Career Guidance",
    "Foreign Settlement",
    "Annual Horoscope",
    "Muhurat & Remedies",
    "9+ Years of Practice",
    "12,000+ Lives Guided",
    "Across 25+ Countries",
];

export default function Ticker() {
    const Row = () => (
        <div className="marquee__track">
            {ITEMS.map((t, i) => (
                <span key={i} className="inline-flex items-center gap-3 text-xs tracking-[0.28em] uppercase text-gold/90 whitespace-nowrap">
                    {t}
                    <Sparkles className="h-3 w-3 text-gold/60" />
                </span>
            ))}
        </div>
    );
    return (
        <div
            aria-hidden="true"
            data-testid="brand-ticker"
            className="fixed top-20 left-0 right-0 z-30 border-y border-gold/15 bg-ink-deep/70 backdrop-blur-md py-2.5"
        >
            <div className="marquee">
                <Row />
                <Row />
            </div>
        </div>
    );
}
